function scrollAnmiateHero() {
  window.addEventListener('scroll', () => {
    const offset = document.body.offsetHeight - window.innerHeight === 0 ? window.innerHeight : document.body.offsetHeight - window.innerHeight;
    document.querySelector('[data-animate-hero]').style.setProperty('--scroll', window.scrollY / offset);
  }, false);
}

function init() {
  const scrollAnimate = document.querySelectorAll('[data-animate-hero]');
  if (scrollAnimate) {
    scrollAnmiateHero();
  }
}

export default init();
